import { DefaultSecondaryButton } from '@frontend/components/common';
import { Application } from '@frontend/functionality/types';
import { getApplicationDisplayName } from '@frontend/functionality/utils';
import { CommonMessage } from '@frontend/lang';
import { TransactionState, TransactionStateName } from '@frontend/transaction/types';

import { KioskList } from '../../components/kiosk-list.component';
import { KioskNavigationFooter } from '../../components/kiosk-navigation-footer.component';
import { KioskNavigationHeader } from '../../components/kiosk-navigation-header.component';
import { PudoTransactionItemComponent } from '../../components/pudo-transaction-item.component';
import { useKioskNavigate } from '../../utils/kiosk-navigation';
import { PudoAwaitingListHeader } from '../pudo-awaiting-list/pudo-awaiting-list-header';
import { usePudoAwaitingList } from '../pudo-awaiting-list/use-pudo-awaiting-list';

const PuDoAwaitingPickUp = () => {
    const navigate = useKioskNavigate();
    const viewProps = usePudoAwaitingList({
        state: TransactionStateName.TRANSACTION_PICK_UP_PENDING,
        sortField: 'dropped_off_timestamp',
        badgeType: 'awaiting-pick-up'
    });

    return (
        <div className='bg-background-default flex size-full flex-col items-center justify-start overflow-hidden'>
            <KioskNavigationHeader
                title={CommonMessage.DETAIL.MANAGE(CommonMessage.OBJECTS.SPOT.DISTRI_SPOT)}
                onBack={() => navigate(-1)}
            />
            <div className='flex size-full flex-col items-start justify-start gap-3 overflow-y-auto px-6 py-4'>
                <PudoAwaitingListHeader
                    title={
                        <>
                            {getApplicationDisplayName(Application.PUDO)}: {TransactionState.TRANSACTION_PICK_UP_PENDING.displayName}
                        </>
                    }
                    isNewestFirst={viewProps.isNewestFirst}
                    onToggleSort={viewProps.toggleSortDirection}
                />
                <KioskList
                    id='pudo-awaiting-pick-up'
                    fetch={viewProps.fetch}
                    rowElement={(transaction, _index, isLast) => (
                        <PudoTransactionItemComponent
                            key={transaction.id}
                            transaction={transaction}
                            isLast={isLast}
                            badgeType={viewProps.badgeType}
                        />
                    )}
                    emptyText={CommonMessage.ERRORS.ENTITIES_NOT_FOUND(<span className='lowercase'>{CommonMessage.OBJECTS.TRANSACTION.PLURAL}</span>)}
                />
            </div>
            <KioskNavigationFooter
                leftButton={
                    <DefaultSecondaryButton
                        text={CommonMessage.BUTTONS.GO_BACK}
                        onClick={() => navigate(-1)}
                    />
                }
            />
        </div>
    );
};

export default PuDoAwaitingPickUp;
